(function(){
  'use strict';
  if(window.__mxpGiftRemoveSafeV1)return;
  window.__mxpGiftRemoveSafeV1=true;

  var scheduled=false;

  function addMainRemove(line){
    if(!line||!line.matches('[data-mxp-promo-gift="1"]'))return;
    var actions=line.querySelector('.mxp3actions');
    if(!actions||actions.querySelector('[data-mxp-gift-remove-safe]'))return;
    var key=String(line.getAttribute('data-mxp-gift-key')||'').trim();
    if(!key)return;

    var button=document.createElement('button');
    button.type='button';
    button.className='mxp3rm';
    button.setAttribute('data-qty-change',key);
    button.setAttribute('data-qty','0');
    button.setAttribute('data-mxp-gift-remove-safe','1');
    button.textContent='Supprimer';
    actions.appendChild(button);
  }

  function addDrawerRemove(line){
    if(!line||!line.matches('[data-mxp-promo-gift="1"]'))return;
    var actions=line.querySelector('.mxp-drawer-actions');
    if(!actions||actions.querySelector('[data-mxp-remove]'))return;

    var button=document.createElement('button');
    button.type='button';
    button.className='mxp-drawer-remove';
    button.setAttribute('data-mxp-remove','');
    button.setAttribute('data-mxp-gift-remove-safe','1');
    button.textContent='Supprimer';
    actions.appendChild(button);
  }

  function ensure(){
    scheduled=false;
    document.querySelectorAll('[data-mxp3] .mxp3line[data-mxp-promo-gift="1"]').forEach(addMainRemove);
    document.querySelectorAll('#CartDrawer [data-mxp-line][data-mxp-promo-gift="1"]').forEach(addDrawerRemove);
  }

  function schedule(){
    if(scheduled)return;
    scheduled=true;
    if(window.requestAnimationFrame)requestAnimationFrame(ensure);
    else setTimeout(ensure,0);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});
  else schedule();

  document.addEventListener('cart:updated',schedule);
  window.addEventListener('pageshow',schedule);

  if(window.MutationObserver){
    var observer=new MutationObserver(schedule);
    var start=function(){
      var main=document.getElementById('MainContent');
      var drawer=document.getElementById('CartDrawer');
      if(main)observer.observe(main,{childList:true,subtree:true});
      if(drawer)observer.observe(drawer,{childList:true,subtree:true});
    };
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
    else start();
  }
})();